import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type BacksplashFeatureParams = FeatureHoookParams;
export const useBacksplashLayerFeature = (_params: BacksplashFeatureParams = {}): Feature<boolean> => {
	const [controller] = useDesign<Controller, { options: { showBacksplashes: boolean }}>();

	useSubscription(controller, false, [['layer-option-backsplash', '*']]);

	const controllerSupportsFeature = (controller?.options?.showBacksplashes ?? null) !== null;
	const showLayer = controller?.options?.showBacksplashes ?? true;

	const tooltip = (() => {
		const showHide = showLayer ? lang.layer.tooltip.hide : lang.layer.tooltip.show;
		return `${showHide} ${lang.layer.label.backsplashes} ${lang.layer.layer}`;
	})();

	return {
		name: 'showBacksplash',
		label: lang.layer.label.backsplashes,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled: !controllerSupportsFeature,
		value: showLayer,
		hidden: false,
		handler: () => {
			if (controller) {
				controller.options.showBacksplashes = !showLayer;
			}
		}
	};
};
